export const TITLE = "Pyme Rural - Plataforma de Cobros";
export const loaderColor = "#083050";
